import React from "react";
import ReactDOM from "react-dom";
import KeycloakService from "./service/KeycloakService";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store";
import rootSaga from "./store/sagas";
import { Provider } from "react-redux";

const store = configureStore();
store.runSaga(rootSaga);

const renderApp = () =>
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );
KeycloakService.initKeycloak(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
